export const TV_CHANNEL_NAME = 'vamos-tamos-tv';

export const getStorageKey = (tournamentName) =>
  `tv-state-${encodeURIComponent(tournamentName || '')}`;

export const postTvState = (tournamentName, encodedState, channelRef) => {
  if (!tournamentName || !encodedState) return;

  try {
    const key = getStorageKey(tournamentName);
    localStorage.setItem(key, encodedState);
  } catch (error) {
    console.warn('Unable to persist TV state to storage', error);
  }

  try {
    channelRef?.current?.postMessage({
      name: tournamentName,
      state: encodedState,
      ts: Date.now(),
    });
  } catch (error) {
    console.warn('Unable to broadcast TV state', error);
  }
};
